import React from 'react';

export function Loader({ size = 'md', className = '' }) {
    const sizes = {
        sm: 'w-4 h-4',
        md: 'w-8 h-8',
        lg: 'w-12 h-12',
        xl: 'w-16 h-16',
    };

    return (
        <div className={`${sizes[size]} ${className}`}>
            <svg className="animate-spin" viewBox="0 0 24 24">
                <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                    fill="none"
                />
                <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
            </svg>
        </div>
    );
}

export function PageLoader() {
    return (
        <div className="flex items-center justify-center min-h-[400px]">
            <div className="flex flex-col items-center gap-4">
                <Loader size="lg" className="text-purple-600" />
                <p className="text-slate-500 dark:text-slate-400 animate-pulse">Loading...</p>
            </div>
        </div>
    );
}

export function Skeleton({ className = '', variant = 'text' }) {
    const variants = {
        text: 'h-4 rounded',
        title: 'h-6 rounded w-1/3',
        circle: 'rounded-full',
        rect: 'rounded-lg',
    };

    return (
        <div
            className={`
        animate-pulse bg-slate-200 dark:bg-slate-700
        ${variants[variant]}
        ${className}
      `}
        />
    );
}

export default Loader;
